export const firstPolygon = <T>(value: unknown): T[] => {
  if (!Array.isArray(value) || value.length === 0) return [];
  return Array.isArray(value[0]) ? (value[0] as T[]) : (value as T[]);
};

export const normalizeMultiPolygon = <T>(value: unknown): T[][] => {
  if (!Array.isArray(value) || value.length === 0) return [];
  return Array.isArray(value[0]) ? (value as T[][]) : [value as T[]];
};

export const wrapPolygon = <T>(polygon: T[] | null | undefined): T[][] => {
  if (!Array.isArray(polygon) || polygon.length === 0) return [];
  return [polygon];
};

export const replacePolygonAtIndex = <T>(polygons: T[][], index: number, polygon: T[]): T[][] => {
  if (index < 0) return polygons;
  const nextPolygons = polygons.slice();
  while (nextPolygons.length <= index) {
    nextPolygons.push([]);
  }
  nextPolygons[index] = polygon;
  return nextPolygons;
};
